var pt_br = {
    values: {
        datetime_format: 'dd/mm/yyyy HH:MM:ss',
        'Invalid date': 'Data inválida',
        'JSON Configuration required': 'A configuração JSON é obrigatória',
        'E-mail body is required': 'Corpo do E-mail é obrigatório',
        'Subject is required': 'Assunto do E-mail é obrigatório.',
        'E-mail Subject': 'Assunto do E-mail.',
        'E-mail Body': 'Corpo do E-mail.',
        'Query Configuration': 'Configuração da Consulta.',
        BLACK: 'PRETO',
        WHITE: 'BRANCO',
        RED: 'VERMELHO',
        'BRIGHT GREEN': 'VERDE CLARO',
        BLUE: 'AZUL',
        YELLOW: 'AMARELO',
        PINK: 'ROSA',
        TURQUOISE: 'TURQUESA',
        'DARK RED': 'VERMELHO ESCURO',
        GREEN: 'VERDE',
        'DARK BLUE': 'AZUL ESCURO',
        'DARK YELLOW': 'AMARELO ESCURO',
        VIOLET: 'VIOLETA',
        TEAL: 'CERCETA',
        'GREY 25 PERCENT': '25% CINZA',
        'GREY 50 PERCENT': '50% CINZA',
        'CORNFLOWER BLUE': 'CENTÁUREA AZUL',
        MAROON: 'VINHO',
        'LEMON CHIFFON': 'AMARELO CLARO',
        'LIGHT TURQUOISE1': 'TURQUESA CLARO',
        ORCHID: 'ORQUÍDEA',
        CORAL: 'CORAL',
        'ROYAL BLUE': 'AZUL REAL',
        'LIGHT CORNFLOWER BLUE': 'AZUL PERVINCA',
        'Header Background Color': 'Cor do Fundo do Cabeçalho',
        'Header Font Color': 'Cor da Fonte do Cabeçalho',
        Result: 'Resultado',

        'Run and Monitor': 'Executar e Monitorar',
        'Instance status': 'Status da instância',
        Schedule: 'Agendamento',
        Disabled: 'Desativado',
        'Currently running': 'Em execução agora',
        Yes: 'Sim',
        No: 'Não',
        'Running since': 'Em execução desde',
        'Last run': 'Última execução',
        'Not available': 'Não disponível',

        PENDING: 'Pendente',
        RUNNING: 'Em execução',
        OK: 'Ok',
        ERROR: 'Erro',

        'Execute now': 'Executar agora',
        Refresh: 'Atualizar',
        Close: 'Fechar',
        'Request successful. The execution will start in a few moments':
            'Solicitação realizada com sucesso. A execução deve iniciar em alguns momentos',
        'The task is already running': 'A tarefa já está em execução',
        'Available executor': 'Executor disponível',
        sectionTemplateActive: 'Ativo',
        Discard: "Descartar",
        }
}

module.exports = pt_br
